import { render, staticRenderFns } from "./DelegationOrderTravelService.vue?vue&type=template&id=455056e4&scoped=true&"
import script from "./DelegationOrderTravelService.vue?vue&type=script&lang=js&"
export * from "./DelegationOrderTravelService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455056e4",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardText,VDialog,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('455056e4')) {
      api.createRecord('455056e4', component.options)
    } else {
      api.reload('455056e4', component.options)
    }
    module.hot.accept("./DelegationOrderTravelService.vue?vue&type=template&id=455056e4&scoped=true&", function () {
      api.rerender('455056e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DelegationOrder/DelegationOrderTravelService.vue"
export default component.exports